import get from 'lodash/get';

const getEventName = () => {
  return {
    processing: {
      application_event: 'submitted',
      event_action: '',
      event_category: '',
      event_content: '',
      event_subcategory: '',
    },
    landing: {
      application_event: '',
      event_action: '',
      event_category: '',
      event_content: '',
      event_subcategory: '',
    },
    errorPage: {
      application_event: '',
      event_action: 'application',
      event_category: 'error',
      event_content: 'technical error',
      event_subcategory: '',
    },
  };
};

const getEventData = (currentPage) => {
  return {
    ...get(getEventName(), currentPage),
  };
};

export default getEventData;
